(function() {
  'use strict';

  angular
    .module('admin.event.service', [])
    .factory('EventService', EventService);

  /** @ngInject */
  function EventService($http, $q, API) {

    function list(startDate, endDate){
        var defered = $q.defer();

        $http.get(API.API_URL + 'admin/event_packs?start-date=' + startDate + '&end-date=' + endDate)
          .success(defered.resolve);

        return defered.promise;
    }

    function listEventByChannels(id){
        var defered = $q.defer();

        $http.get(API.API_URL + 'admin/channels/' + id + '/event_packs')
          .success(defered.resolve);

        return defered.promise;
    }

    function listChannels(){
        var defered = $q.defer();

        $http.get(API.API_URL + 'admin/channels')
          .success(defered.resolve);

        return defered.promise;
    }

    function listSets(id){
        var defered = $q.defer();

        $http.get(API.API_URL + 'admin/channels/' + id + '/sets')
          .success(defered.resolve);

        return defered.promise;
    }

    function listCollectibles(id){
      var defered = $q.defer();

      $http.get(API.API_URL + 'admin/sets/' + id + '/collectibles')
        .success(defered.resolve);

      return defered.promise;
    }

    function listPacks(id){
      var defered = $q.defer();

      $http.get(API.API_URL + 'admin/sets/' + id + '/bundles')
        .success(defered.resolve);

      return defered.promise;
    }

    function get(id){
        var defered = $q.defer();

        $http.get(API.API_URL + 'admin/event_packs/' + id)
          .success(defered.resolve);

        return defered.promise;
    }

    function save(setId, model){
        var defered = $q.defer();

        $http.post(API.API_URL + 'admin/event_packs/' + setId, model)
          .success(defered.resolve);

        return defered.promise;
    }

    function update(id, model){
        var defered = $q.defer();

        $http.put(API.API_URL + 'admin/event_packs/' + id, model)
          .success(defered.resolve);

        return defered.promise;
    }

    function remove(id){
        var defered = $q.defer();

        $http.delete(API.API_URL + 'admin/event_packs/' + id)
          .success(defered.resolve)
          .error(defered.reject);

        return defered.promise;
    }

    function getBundle(id){
      var defered = $q.defer();

      $http.get(API.API_URL + 'admin/bundles/' + id)
        .success(defered.resolve);

      return defered.promise;
    }

    function getChannelPostByBundleUrl(channelId, id){
      var defered = $q.defer();

      $http.get(API.API_URL + 'admin/channels/' + channelId + '/channel_posts/bundles/' + id)
        .success(defered.resolve);

      return defered.promise;
    }

    return{
        list: list,
        listChannels: listChannels,
        listSets: listSets,
        listPacks: listPacks,
        get: get,
        save: save,
        update: update,
        remove: remove,
        listEventByChannels: listEventByChannels,
        getBundle: getBundle,
        getChannelPostByBundleUrl: getChannelPostByBundleUrl,
        listCollectibles: listCollectibles
    };

  }

})();
